// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { Map } from 'immutable';
import type { PayloadMetaAction } from 'typesafe-actions';
import { ContentState, handleContentRoutines } from '../common/utils/content-state.js';
import simpleReducer from '../common/utils/simple-reducer.js';
import { getContentUsage, getPreviewRoutes } from './actions.js';
import { LINKS, PREVIEW_SITES } from './constants.js';
import type { ShapePreview, SiteUsage } from './types.js';

export const initialState = Map({
  [LINKS]: Map(),
  [PREVIEW_SITES]: new ContentState()
});

export default simpleReducer(
  initialState,
  handleContentRoutines([
    {
      routine: getContentUsage,
      type: 'query',
      path: (action: PayloadMetaAction<any, any, any>): string[] => [LINKS, action.meta.contentId],
      payloadSelector: (payload: { result: SiteUsage[] }): SiteUsage[] => payload.result
    },
    {
      routine: getPreviewRoutes,
      type: 'query',
      path: (): string[] => [PREVIEW_SITES],
      payloadSelector: (payload: { result: ShapePreview[] }): ShapePreview[] => payload.result
    }
  ])
);
